import { getMadaBinList } from '@/api/common'
import Config from '@/config'

const state = {
  madabins: [],
}

const getters = {
  madabins(state) {
    return state.madabins || []
  },
}

const mutations = {
  SET_MADA_BIN_LIST(state, list) {
    state.madabins = [...list]
  },
}

const actions = {
  async getMadaBinList({ commit }) {
    const res = await getMadaBinList()

    commit(
      'SET_MADA_BIN_LIST',
      Config.isProduction ? res.data : [...res.data, '465858']
    )

    return res
  },
}

export default { namespaced: true, state, getters, mutations, actions }
